/* eslint-disable no-param-reassign,no-unused-vars */
/* global G */
import { curry } from 'lib/util'

/**
 * Clears the list `component`, asks it to reload and updates the UI.
 *
 * @type Gaia.AppModule.EventHandler
 */
const clearAndReloadList = async (module, component, event) => {
  component[G.STATE].reload = {}
  component[G.STATE].data = null
  component[G.STATE].page = null
  module[G.ADAPTER][G.UI].update(module)
}

export default curry(clearAndReloadList)
